import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { Globe, Plus, Trash2 } from "lucide-react"
import { useCallback } from "react"
import { usePermissions } from "@/lib/hooks/usePermissions"

export const domains = {
  title: "Domains",
  description: "Manage your organization's domains.",
  route: "/docu/domains",
  url: "/docu/domains",
  icon: Globe,
  component,
  group: "docs",
  resource: "collections",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"domains">> = {
  name: { header: "Name", size: 600 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {
  const { navigate, team } = usePage()
  const { canCreate, canDelete } = usePermissions()

  const menu: DropdownMenuContents = [
    ...(canDelete("collections") ? [{
      title: "Delete", action: async (v) => {
        await supabase.from("domains").delete().eq("id", v.id)
      },
      icon: <Trash2 />,
      ask: "Are you sure you want to delete this domain?",
    }] : []),
  ]

  const filter = useCallback(q => q.eq("team", team?.id), [team])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("collections") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/docu/domains/new')}><Plus className="h-4 w-4" />New Domain</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="domains"
        columns={columns}
        showSelection
        onRowClick={"/docu/domains"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        filter={filter}
        enableServerSideFiltering={true}
        searchableColumns={["name"]}
      />
    </div>
  </Page>
}
